import React, { useState } from "react";

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
      title: "1. What is DEFIN?",
      content:
        "DEFIN is a staking platform that allows users to earn daily yields and team rewards by staking USDT (BEP20) or DEFIN tokens.",
    },
    {
      title: "2. How does staking work on DEFIN?",
      content:
        "Users can stake a minimum of $20 and a maximum of $1000, in multiples of $10. Staked funds generate a daily yield of 3%.",
    },
    {
      title: "3. What are the staking limits?",
      content: [
        "Minimum Stake: $20",
        "Maximum Stake: $1000",
        "Stake must be in multiples of $10",
      ],
    },
    {
      title: "4. What is the daily yield on my stake?",
      content: "You will earn 3% daily on your staked amount.",
    },
    {
      title: "5. What are the team yield rewards?",
      content: [
        "DEFIN offers a referral-based team yield structure:",
        "Level 1: 5%",
        "Level 2: 3%",
        "Level 3: 1%",
      ],
    },
    {
      title: "6. What is the reward capability?",
      content:
        "The maximum earnings from staking and referrals are 1.5X of the deposited amount.",
    },
    {
      title: "7. What tokens can I use for deposits?",
      content: ["You can deposit using:", "USDT (BEP20)", "DEFIN Token"],
    },
    {
      title: "8. What token is used for withdrawals?",
      content: "Withdrawals are made in DEFIN Token.",
    },
    {
      title: "9. What are the withdrawal conditions?",
      content: ["Minimum Withdrawal: $10:", "Withdrawal Fee: 1%"],
    },
  ];

  return (
    <div className="content-body pt-0">
      <div className="p-4 rounded" style={{ background: "#0b0b0b99" }}>
        <h2 className="fs-25 text-center mb-4 text-white">FAQ</h2>
        <div className="accordion">
          {accordionData.map((item, index) => (
            <div
              key={index}
              className={`accordion-item ${openIndex === index ? "open" : ""}`}
            >
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-down accordion-item-header-icon"
                >
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </div>
              <div className="accordion-item-description-wrapper">
                <div className="accordion-item-description">
                  <hr className="my-1" />
                  {Array.isArray(item.content) ? (
                    item.content.map((line, i) => <p key={i}>{line}</p>)
                  ) : (
                    <p className="py-0 mb-2">{item.content}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
